import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const updatePassword: UseCase<AuthRepository, 'updatePassword'> = repository => {
  return async updatePassword => {
    await repository.updatePassword(updatePassword)
  }
}
